<template>
    <nav class="primary-nav" :class="{ '--show': showNav }">
        <div class="spacer --top">
            <NuxtLink class="logo" to="/">
                <LogoStamp />
            </NuxtLink>
        </div>
        <ul>
            <li v-for="navItem in navItems" :key="`navItem${navItem.path}`" @click="showNav = false">
                <NuxtLink :to="navItem.path">{{ navItem.label }}</NuxtLink>
            </li>
        </ul>
        <div class="spacer --bottom" @click="showNav = false">
            <TradingHours />

        </div>

        <a class="mobile-nav-toggle" @click="showNav = !showNav">
            <span></span>
            <span></span>
            <span></span>
        </a>
    </nav>
</template>

<script>
export default {
    setup() {
        const route = useRoute()
        const navItems = [
            {
                label: 'drinks',
                path: '/drinks'
            },
            {
                label: 'food',
                path: '/food'
            },
            {
                label: 'our coffee',
                path: '/our-coffee'
            },
            // {
            //     label: 'gallery',
            //     path: '/gallery'
            // },
            {
                label: 'about',
                path: '/about'
            },
            {
                label: 'contact us',
                path: '/contact-us'
            }
        ]
        return {
            route,
            navItems
        }
    },

    watch: {
        showNav(showNav) {
            if (showNav) {
                window.scrollTo(0, 0);
            }
        }
    },

    data() {
        return {
            showNav: this.route.path === '/' || false
        }
    }
}
</script>